import { render, staticRenderFns } from "./parkOrderIncome.vue?vue&type=template&id=52c244d4&scoped=true&"
import script from "./parkOrderIncome.vue?vue&type=script&lang=js&"
export * from "./parkOrderIncome.vue?vue&type=script&lang=js&"
import style0 from "./parkOrderIncome.vue?vue&type=style&index=0&id=52c244d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c244d4",
  null
  
)

export default component.exports